import { useContext } from 'react';
import { useObjectAccessModal, useReadOnlyObjectAccessModal } from '@/components/ObjectAccess';
import { ObjectAccessButton, SkeletonAccess } from '@/components/ObjectAccess/Button';
import { useGroupFeatures } from '@trinity/chat-components/containers/Chat/hooks.js';
import { ObjectAccessContainer } from '@/containers/ObjectAccess/ObjectAccessContainer';
import { WorkspaceFilePreviewLoadingContext } from '@/containers/Workspace.File.Preview/Context';
import { useWorkspaceFileState } from '@/containers/Workspace.File.Preview/hooks';

type Props = unknown;

export const Access = (props: Props) => {
  const isLoading = useContext(WorkspaceFilePreviewLoadingContext);

  return isLoading
    ? <SkeletonAccess />
    : <AccessContainer />;
};

Access.displayName = 'File.Header.Access';

const AccessContainer = (props: Props) => {
  const state = useWorkspaceFileState();
  const features = useGroupFeatures();
  const canUploadFiles = features.uploadFiles;

  if (state.capabilities.canManageAccess && canUploadFiles) {
    return <InteractiveAccess />;
  }

  return <NonInteractiveAccess />;
};

const NonInteractiveAccess = (props: Props) => {
  const state = useWorkspaceFileState();
  const [toggleAccessModal, ObjectAccessModal] = useReadOnlyObjectAccessModal();

  return (
    <>
      <ObjectAccessButton
        count={state.meta.accessCount}
        onClick={toggleAccessModal} />
      <ObjectAccessContainer objectId={state.object.id} workspaceId={state.object.workspaceId}>
        <ObjectAccessModal />
      </ObjectAccessContainer>
    </>
  );
};

const InteractiveAccess = (props: Props) => {
  const state = useWorkspaceFileState();
  const [toggleAccessModal, ObjectAccessModal] = useObjectAccessModal();

  return (
    <>
      <ObjectAccessButton
        count={state.meta.accessCount}
        onClick={toggleAccessModal} />
      <ObjectAccessContainer objectId={state.object.id} workspaceId={state.object.workspaceId}>
        <ObjectAccessModal />
      </ObjectAccessContainer>
    </>
  );
};

InteractiveAccess.displayName = 'File.Header.Access.Interactive';